import {useGameServerConnection} from '@glark-newco/game-library';
import {Button, Group} from '@mantine/core';
import {IconPlayerPlay} from '@tabler/icons-react';
import {ReviewStatsPayload, SupplyChainPayload} from '../SupplyChainPayloadTypes';

export function ReviewStatsButton() {
    const {publishPlayerAction} = useGameServerConnection<SupplyChainPayload>();

    function publishReviewStatsEvent() {
        publishPlayerAction({
            type: 'reviewStats',
        } as ReviewStatsPayload);
    }

    return (
        <Group
            data-testid="facilitator-actions"
            style={{
                width: '20%',
                position: 'absolute',
                pointerEvents: 'initial',
                right: '1rem',
                top: '7.75rem',
            }}
        >
            <Button
                rightSection={<IconPlayerPlay size={14}/>}
                radius={'xl'}
                variant="gradient"
                onClick={() => publishReviewStatsEvent()}
                gradient={{from: 'blue', to: 'teal', deg: 90}}
                size={'lg'} bd={'0.15em solid white'}
            >
                End Game - Review stats
            </Button>
        </Group>
    );
}
